import { render } from "./CaseViewerElement.vue?vue&type=template&id=04f49b36&scoped=true"
import script from "./CaseViewerElement.vue?vue&type=script&lang=js"
export * from "./CaseViewerElement.vue?vue&type=script&lang=js"

import "./CaseViewerElement.vue?vue&type=style&index=0&id=04f49b36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f49b36"]])

export default __exports__